import { IPopUpSectionData, IPopUpStyle, PopUpSectionData } from "@pageBuilder/typings";
import { MeshSectionRendererBase } from "../mesh-section-renderer-base";

export class PopUpSectionRenderer extends MeshSectionRendererBase {

    protected override createNewSection(): HTMLElement {
        const element = document.createElement("div");
        element.setAttribute("data-section", "popUpSection");
        element.classList.add("page-pop-up");

        const content = this.createContentElement();

        const background = document.createElement("div");
        background.classList.add("background");

        const closeWrapper = document.createElement("div");
        closeWrapper.classList.add("close-wrapper");

        const closeButton = document.createElement("button");
        closeButton.classList.add("popup-close-btn");
        closeButton.setAttribute("aria-label", "Close popup");

        const span = document.createElement("span");
        closeButton.append(span);
        closeWrapper.append(closeButton);

        element.append(background, content, closeWrapper);
        return element;
    }

    protected override renderInternal(element: HTMLElement, data: IPopUpSectionData): HTMLElement {
        const popupElement = super.renderInternal(element, data);

        this.renderStyles(popupElement, data.style);
        this.renderScreen(popupElement, data);
        this.renderSectionVisibility(popupElement, data);

        return popupElement;
    }

    protected override renderStyles(sectionElement: HTMLElement, style?: IPopUpStyle | null): void {
        if (!style) {
            return;
        }

        const stylesProp = super.getBaseStyleCssItems(style);

        stylesProp.tryAdd("--close-color", `${style.closeColor.toString() ?? PopUpSectionData.defaultStyle.closeColor}`);
        stylesProp.tryAdd("--pop-up-width", `${style.widthInPc.toString() ?? PopUpSectionData.defaultStyle.widthInPc.toString()}vw`);

        stylesProp.tryAdd("--border-top-left-radius", `${style.borderRadius?.topLeftPx.toString() ?? PopUpSectionData.defaultStyle.borderRadius?.topLeftPx.toString()}px`);
        stylesProp.tryAdd("--border-top-right-radius", `${style.borderRadius?.topRightPx.toString() ?? PopUpSectionData.defaultStyle.borderRadius?.topRightPx.toString()}px`);
        stylesProp.tryAdd("--border-bottom-left-radius", `${style.borderRadius?.bottomLeftPx.toString() ?? PopUpSectionData.defaultStyle.borderRadius?.bottomLeftPx.toString()}px`);
        stylesProp.tryAdd("--border-bottom-right-radius", `${style.borderRadius?.bottomRightPx.toString() ?? PopUpSectionData.defaultStyle.borderRadius?.bottomRightPx.toString()}px`);

        this.styleService.setStyle(sectionElement, `#${sectionElement.id}`, stylesProp.data);
    }

    protected override cleanupInternal(element: HTMLElement): void {
        this.cleanupScreen(element);
    }

}
